import React from 'react';
import css from './BenefitLine.module.css';
// Small benefit line (Sam, Oct 24 2026, TEST): one per page, never repeated on a page.
const BenefitLine = ({ text, tone, center, className }) => (
  <p className={[css.root, tone === 'blue' ? css.blue : '', center ? css.center : '', className || ''].join(' ')} data-benefit-line="true">
    <span className={css.dot} aria-hidden="true" />
    {text}
  </p>
);
export default BenefitLine;
